import Vue from 'vue'
import { ToastPlugin, ModalPlugin, CollapsePlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import dotenv from 'dotenv'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@axios'
import '@/libs/clipboard'
import '@/libs/vue-select'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(CollapsePlugin)

// Composition API
Vue.use(VueCompositionAPI)

dotenv.config()

// import core styles
require('@core/scss/core.scss')
// eslint-disable-next-line import/no-unresolved
require('@/assets/cssAnimation/animation.css')
require('@/assets/cssIcons/style.css')
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard
// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
